module.exports = __webpack_public_path__ + "img/127.e83a8064.jpg";